import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { FormControlMobile } from '@alfalab/core-components-form-control/esm/mobile';
import { BaseInput } from '../components/base-input/Component.js';

var InputMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseInput, __assign({}, restProps, { FormControlComponent: FormControlMobile, ref: ref }))); });

export { InputMobile };
